import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

export const allPermissionsPresent = (feature, userData) => {
    const permissions = userData && userData.permissions;
    return permissions && _.castArray(feature).every(feature => permissions[feature]);
};

const Feature = connect((state, { feature }) => ({
    hasPermission: allPermissionsPresent(feature, state.user)
}))(({ component = null, hasPermission, children }) => (hasPermission ? children : component));

Feature.propTypes = {
    feature: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
    component: PropTypes.node
};

export default Feature;



/** WEBPACK FOOTER **
 ** ../src/dash/front/hoc/withFeature.js
 **/